import axios from "axios";
const publicAPI = axios.create({
    baseURL: "https://backend.newbrindha.com"   
});

export default publicAPI;